import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { IparamsSplitTabs } from '@/courses/interfaces/params-split-tabs.interface';
import { COURSE_EVENTS } from '@/content/values/events';

@Component({ name: 'ed-split-tabs' })
export default class EdSplitTabs extends Vue {

  /* Props */
  @Prop() readonly params: IparamsSplitTabs;
  private tabOptions : string[] = ['ResponseTab', 'SolutionTab', 'AnswerTab'];
  
  get isSynchronisingEdupad() : boolean {
    return this.$store.state.HomeworksStore.isSynchronisingEdupad;
  }

  /* Methods */
  public setTab(contentId: string, elementId: string) {
    if (this.isSynchronisingEdupad) {
      return;
    }
    if(this.tabOptions.includes(this.params.tabSelected) && contentId === 'ProblemTab'){
      return;
    }

    if(this.params.tabSelected !== contentId){
      this.$emit('setTab' , contentId);
      this.$edEventBus.$emit(COURSE_EVENTS.SEND_PRESENTATION_LAYOUT, {elementId, type: 'layout'});
    }
  }

 }
